import { gql } from "@apollo/client";

export const FETCH_SUPPLIER_STOCKS_OVERVIEW = gql`
  query FETCH_SUPPLIER_STOCKS_OVERVIEW {
    supplierStockOverview
  }
`;

export const FETCH_PRODUCTS_USE_SUPPLIER_STOCK = gql`
  query FETCH_PRODUCTS_USE_SUPPLIER_STOCK {
    products(useSupplierStock: true, hasSupplierStocks: true) {
      total
      results {
        id
        odooId
        name
        nameCn
        number
        supplierStockPlanningQty
        suppliers: stockSuppliers {
          id
          nickName
        }
      }
    }
  }
`;

export const FETCH_SUPPLIER_PENDING_INVENTORY_UPDATE_REQUEST = gql`
  query FETCH_SUPPLIER_PENDING_INVENTORY_UPDATE_REQUEST($id: ID!) {
    supplierStockUpdateRequest(id: $id) {
      id
      stocks {
        updateType
        supplierStockRecordId
        product {
          id
          name
          number
        }
        qty
        readyDate
        remark
      }
      state
    }
  }
`;

export const CONFIRM_SUPPLIER_STOCK_UPDATE_REQUEST = gql`
  mutation CONFIRM_SUPPLIER_STOCK_UPDATE_REQUEST(
    $id: ID!
    $state: String!
    $recomputePlans: Boolean
  ) {
    confirmSupplierStockUpdateRequest(
      id: $id
      state: $state
      recomputePlans: $recomputePlans
    ) {
      request {
        id
        state
      }
    }
  }
`;

export const FETCH_PRODUCT_SUPPLIER_STOCK = gql`
  query FETCH_PRODUCT_SUPPLIER_STOCK($id: ID!) {
    product(id: $id) {
      id
      odooId
      number
      name
    }
    productSupplierStockReservations(productId: $id) {
      id
      stockRecord {
        id
        qty
        supplier {
          id
          name
        }
        readyDate
      }
      plan {
        id
      }
    }
    supplierStock(productId: $id)
  }
`;

export const CREATE_SUPPLIER_STOCK_RECORD = gql`
  mutation CREATE_SUPPLIER_STOCK_RECORD(
    $productId: ID!
    $supplierId: ID!
    $readyDate: DateTime!
    $qty: Int!
    $remark: String
    $recomputePlans: Boolean
  ) {
    createSupplierStockRecord(
      productId: $productId
      supplierId: $supplierId
      readyDate: $readyDate
      qty: $qty
      remark: $remark
      recomputePlans: $recomputePlans
    ) {
      supplierStockRecord {
        id
        qty
        latestQty
        readyDate
        remark
        product {
          id
          supplierStockForecast
          supplierStocks {
            id
            qty
            readyDate
            supplier {
              id
              name
            }
            usages {
              id
              plan {
                name
                wisCustomer {
                  name
                }
                odooObject {
                  objectName
                  objectType
                }
                state
              }
              qty
            }
            remark
          }
        }
      }
    }
  }
`;

export const FETCH_SUPPLIER_STOCK_RECORD = gql`
  query FETCH_SUPPLIER_STOCK_RECORD($id: ID!) {
    supplierStockRecord(id: $id) {
      id
      supplier {
        id
        name
      }
      product {
        id
        number
        name
      }
      qty
      remark
    }
  }
`;

export const UPDATE_SUPPLIER_STOCK_RECORD = gql`
  mutation UPDATE_SUPPLIER_STOCK_RECORD(
    $id: ID!
    $qty: Int
    $supplierId: ID
    $readyDate: DateTime
    $remark: String
    $recomputePlans: Boolean
  ) {
    updateSupplierStockRecord(
      id: $id
      qty: $qty
      supplierId: $supplierId
      readyDate: $readyDate
      remark: $remark
      recomputePlans: $recomputePlans
    ) {
      supplierStockRecord {
        id
        supplier {
          id
          name
        }
        readyDate
        product {
          id
          supplierStockForecast
          supplierStocks {
            id
            qty
            readyDate
            supplier {
              id
              name
            }
            usages {
              id
              plan {
                name
                wisCustomer {
                  name
                }
                odooObject {
                  objectName
                  objectType
                }
                state
              }
              qty
            }
            remark
          }
        }
        qty
        remark
      }
    }
  }
`;

export const FETCH_SUPPLIER_PENDING_INVENTORY_UPDATE_REQUESTS = gql`
  query FETCH_SUPPLIER_PENDING_INVENTORY_UPDATE_REQUESTS {
    supplierStockUpdateRequests {
      total
      results {
        id
        supplier {
          name
        }
        createdAt
        state
      }
    }
  }
`;

export const RESERVE_SUPPLIER_STOCK = gql`
  mutation RESERVE_SUPPLIER_STOCK(
    $currentSupplierStockUsageId: ID!
    $reserveSupplierStockRecordId: ID!
  ) {
    reserveSupplierStock(
      currentSupplierStockUsageId: $currentSupplierStockUsageId
      reserveSupplierStockRecordId: $reserveSupplierStockRecordId
    ) {
      result
    }
  }
`;

export const DELETE_SUPPLIER_STOCK_RESERVATION = gql`
  mutation DELETE_SUPPLIER_STOCK_RESERVATION($id: ID!) {
    deleteSupplierStockReservation(id: $id) {
      result
    }
  }
`;
